export enum ResultScreensAbTestGroupName {
  DEFAULT = 'A default',
  NEBULA_LIKE = 'B Nebula',
}
export const RESULT_SCREENS_AB_TEST_NAME = 'Nebula test';

export const FIRST_SCREEN_AB_TEST_NAME = 'Eclipse first screen';

export enum FirstScreenAbTestGroupName {
  CURRENT = 'Default old',
  NEW = 'New screen',
}

export const FIRST_SCREEN_FOUR_VARIANTS_AB_TEST_NAME =
  'First screen (4 variants)';

export enum FirstScreenFourVariantsAbTestGroupName {
  CURRENT = 'A default',
  NEW = 'First screen (4 variants)',
}

export const FIRST_SCREEN_THREE_VARIANTS_AB_TEST_NAME =
  'Eclipse 1 screen 3 variants';

export enum FirstScreenThreeVariantsAbTestGroupName {
  CURRENT = 'A default',
  NEW = 'B 1 screen 3 variants',
}
